const PHI = 1.618033988749895;
const THETA = Math.PI * (3 - Math.sqrt(5));

export function generatePhyllotaxis(
    array,
    center,
    {
        innerRadius = 100,
        outerRadius = 150,
        circleRadius = 0.25,
        maxAutoSize = 3,
        seedsPerTurn = THETA,
        circlePackRatio = 0.2,
    }
) {
    var thickness = outerRadius - innerRadius;
    const count = array.length;

    let radiusToUse = circleRadius;

    if (radiusToUse === "auto") {
        const outerArea = Math.pow(Math.PI * outerRadius, 2);
        const innerArea = Math.pow(Math.PI * innerRadius, 2);
        const donutArea = outerArea - innerArea;

        const areaPerCircle = donutArea / Math.max(array.length, 1);
        const areaWithPackingRatio = areaPerCircle * circlePackRatio;
        const rSquared = areaWithPackingRatio / Math.PI;
        radiusToUse = Math.min(maxAutoSize, Math.sqrt(rSquared));
    }

    return array
        .map((datum, i) => {
            const radius = thickness * (i / count);
            const angleRaw = (seedsPerTurn * i) % (Math.PI * 2);
            const angle = angleRaw - Math.PI / 2;
            return {
                datum,
                angle: angle,
                x: center.x + (radius + innerRadius) * Math.cos(angle),
                y: center.y + (radius + innerRadius) * Math.sin(angle),
                r: radiusToUse,
            };
        })
        .sort((a, b) => a.angle - b.angle)
        .map((d, i) => ({
            ...d,
            index: i,
        }));
}
